import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
//import Login from "./App";
import $ from 'jquery';
import Header from './../../Header';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';

class Okr extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.searchChange = this.searchChange.bind(this);
        this.priortyChange = this.priortyChange.bind(this);
        this.statusChange = this.statusChange.bind(this);
        this.ownerChange = this.ownerChange.bind(this);
        this.departmentChange = this.departmentChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.state = {
            todos: [],
            owners: [],
            todoid:'',
            status: 'all',
            priority: 'all',
            search: '',
            owner: 'all',
            department: 'all',
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            activePage: 1,
            item_count: '',
            loading: 1,
            isLoadMore: 1,
        };
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    back() {
        window.location.href = '/todos';
    }
    searchChange(event) {
        this.setState({search: event.target.value}, function () {
            this.todoList();
        });
    }

    handlePageChange(pageNumber) {
        this.setState({activePage: pageNumber});
        this.todoList(pageNumber);
      }

    

    priortyChange(event) {
        this.setState({priority: event.target.value}, function () {
            this.todoList();
        });
    }
    
    statusChange(event) {
        this.setState({status: event.target.value}, function () {
            this.todoList();
        });
    }

    ownerChange(event) {
        this.setState({owner: event.target.value}, function () {
            this.todoList();
        });
    }

    departmentChange(event) {
        this.setState({department: event.target.value}, function () {
            this.todoList();
        });
    }

    jumpSubmit(event)
    {
        //alert();
        if (event.key == 'Enter') {
            if(!event.target.value.match(/^[0-9]+$/)){
                this.setState({message:'Only numbers'}) 
                return false;
            }
            else {
                fetch(this.state.apiUrl + '/todoRest/viewTodoId/id/' + event.target.value + '/userAuthKey/' + this.state.userAuthKey)
                    .then((Response) => Response.json())
                    .then((responseJson) => {
                        responseJson = this.decrypt(responseJson, 1);
                        if (responseJson.code == 200) {
                            window.location.href = '/viewTodo/' + responseJson.todoid
                            } else {
                                this.setState({message:responseJson.msg}) 
                            }                      
                })
               
            }            
        }
    }

    todoList(page = 1) {
        fetch(this.state.apiUrl + '/todoRest/getTodos/page/'+page+'/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
            this.setState({
                loading:0,
                todos: findresponse.todos,
                owners: findresponse.owner,
                item_count: findresponse.item_count,
            })
        })
    }
    

    

    componentDidMount()
    {
        document.title = "Intranet | OKR";
        if(!localStorage.getItem('userLogin')){     
            this.setState({redirect:true});
          }
        this.todoList();
        $(document).ready(function () {
            //Page Refresh
            setTimeout(function(){
                //ticketsList();
               // window.location.reload();
            },10000);
            //Responsive filter
            $('.top-row .fa-sliders').on('click', function(){
				$(this).closest('.intranet_body').find('.form-section').slideToggle('slow');
			});
        });

    }
    render() {
        if(this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
        }
        return (
                <div>
                 <Header brecum_name="OKR" brecum_page="OKR"/>
                <div class="right_col">
                     <div class="coming_soon"><div class="coming_soon_text">Coming Soon</div></div>
                </div>
                </div>
                );
    }
}

export default Okr;


// WEBPACK FOOTER //
// ./src/components/todo/okr.js